import SearchFilters from 'client/javascript/filters/filters';
import { getStartDateFilter, formatStartDateForIQS } from 'shared/util/date';
import { varsFromServer } from 'client/javascript/client_side_injection_vars';
import { stringify } from 'qs';
import { setupJumbotronForms, updateJumbotrons } from 'client/javascript/jumbotrons';
import { trackInteraction } from 'client/javascript/analytics';

const LOADING_CLASS = 'loading';

let filters;

export function setupProductCards(nearbyBuildings, showSelfServe, selfServe) {
  const hasProductCards = !!document.querySelector('#section-pricing .filter-chips');
  if (!hasProductCards) return;

  const defaultDate = formatStartDateForIQS(getStartDateFilter());

  filters = new SearchFilters({
    defaults: {
      date: defaultDate
    },
    onChange: () => {
      if (showSelfServe) selfServe.updateReserveButtons();
      updateCards();
      updateJumbotrons(filters.capacity.value);
      nearbyBuildings.setupNearbyBuildings(filters.values);
    }
  });

  updateCards();
  setupJumbotronForms();
  updateJumbotrons(filters.capacity.value);
  nearbyBuildings.setupNearbyBuildings(filters.values);
}

async function updateCards() {
  const container = document.querySelector('.product-cards-block');
  container.classList.add(LOADING_CLASS);
  const params = {
    ...varsFromServer.query,
    date: filters.values.date,
    capacity: filters.values.capacity
  };
  const queryParams = stringify(params);
  const response = await fetch(
    `/${varsFromServer.locale}/buildings/${varsFromServer.building.slug}/product_cards?${queryParams}`
  );
  const productCards = await response.text();
  container.innerHTML = productCards;
  container.classList.remove(LOADING_CLASS);
  setupAnalytics();
}

function setupAnalytics() {
  const hotDeskSignupLink = document.querySelector('.hot-desk-signup-link');

  if (hotDeskSignupLink) {
    hotDeskSignupLink.addEventListener('click', trackHotDeskSignupClick);
  }
}

function trackHotDeskSignupClick() {
  const props = {
    label: 'Building Page Hot Desk Signup Link'
  };

  trackInteraction(props);
}
